export default __webpack_public_path__ + "static/media/icon-Circle-close.082545d4.svg";